export enum PayrollDiscriminatorValues {
    DATE_TYPE = 'DATE_TYPE',
    MIN_LIV_ALLOWANCE_GROUP = 'MIN_LIV_ALLOWANCE_GROUP',
    PAYROLL_SCHEMA = 'PAYROLL_SCHEMA',
    PAYROLL_TYPE = 'PAYROLL_TYPE',
    PAYROLL_TYPE_TAX_MANNER = 'PAYROLL_TYPE_TAX_MANNER',
    PERIOD_SWITCH = 'PERIOD_SWITCH',
    SSI_DECLARATION_LAW = 'SSI_DECLARATION_LAW',
    SI_DOCUMENT_TYPE = 'SI_DOCUMENT_TYPE',
    SI_DEDUCTION_LAW = 'SI_DEDUCTION_LAW',
    TEA_OCCUPATION_CODE = 'TEA_OCCUPATION_CODE',
    WT_GROUP = 'WT_GROUP',
    HAZARDOUS_CLASS = 'HAZARDOUS_CLASS',
    TAX_DEDUCTION_GROUP = 'TAX_DEDUCTION_GROUP',
    RND_INCOME_DEDUC_RATE = 'RND_INCOME_DEDUC_RATE',
    RND_DEDUCTION_LAW = 'RND_DEDUCTION_LAW',
    EXECUTION_OFFICE = 'EXECUTION_OFFICE',
    RAD_MAIN_GROUP = 'RAD_MAIN_GROUP',
    RAD_SUB_GROUP = 'RAD_SUB_GROUP',
    REGION = 'REGION',
    REGION_TYPE = 'REGION_TYPE',
    YDS_LANGUAGE_LEVEL = 'YDS_LANGUAGE_LEVEL',
}

export enum PersonnelDiscriminatorValues {
    ASSIGNMENT_METHOD = 'ASSIGNMENT_METHOD',
    ASSIGNMENT_REASON = 'ASSIGNMENT_REASON',
    AUTHORIZATION_LEVEL = 'AUTHORIZATION_LEVEL',
    AWARD_AUTHORITY = 'AWARD_AUTHORITY',
    AWARD_TYPE = 'AWARD_TYPE',
    BANK_CRATE_CODE = 'BANK_CRATE_CODE',
    BRANCH_CODE = 'BRANCH_CODE',
    BRANCH_OF_STUDY = 'BRANCH_OF_STUDY',
    COURT_STAGE = 'COURT_STAGE',
    DIAGNOSTIC_CODE = 'DIAGNOSTIC_CODE',
    DIAGNOSTIC_TYPE = 'DIAGNOSTIC_TYPE',
    EDU_INSTITUTION = 'EDU_INSTITUTION',
    EDUCATION_GROUP = 'EDUCATION_GROUP',
    EDUCATION_SUBTYPE = 'EDUCATION_SUBTYPE',
    EXAM_TYPE = 'EXAM_TYPE',
    SUBEXAM_TYPE_ID = 'SUBEXAM_TYPE_ID',
    EXAMINATION_RESULT = 'EXAMINATION_RESULT',
    EYE_COLOR = 'EYE_COLOR',
    FACULTY = 'FACULTY',
    HAIR_COLOR = 'HAIR_COLOR',
    HIERARCHY_GROUP = 'HIERARCHY_GROUP',
    KIND_OF_DEBT = 'KIND_OF_DEBT',
    GRADUATION_STATUS = 'GRADUATION_STATUS',
    STUDY_TYPE = 'STUDY_TYPE',
    KIND_TYPE = 'KIND_TYPE',
    LABORATORY_TEST = 'LABORATORY_TEST',
    LANGUAGE_LEVEL = 'LANGUAGE_LEVEL',
    LANGUAGE_TYPE = 'LANGUAGE_TYPE',
    LAWSUIT_SUBTYPE = 'LAWSUIT_SUBTYPE',
    LAWSUIT_TYPE = 'LAWSUIT_TYPE',
    LEAVE_METHOD = 'LEAVE_METHOD',
    LEAVE_REASON = 'LEAVE_REASON',
    LIMB = 'LIMB',
    MAKE = 'MAKE',
    MATTER = 'MATTER',
    MEDICAL_SECTION = 'MEDICAL_SECTION',
    NURSE_PROCESS = 'NURSE_PROCESS',
    OBJECT = 'OBJECT',
    OBJECT_CONNECT = 'OBJECT_CONNECT',
    OBJECT_STATUS = 'OBJECT_STATUS',
    PAYMENT_WAY = 'PAYMENT_WAY',
    PEOPLE_STATUS = 'PEOPLE_STATUS',
    RANK_CODE = 'RANK_CODE',
    REAL_ESTATE_TYPE = 'REAL_ESTATE_TYPE',
    REASON_OF_ISSUE = 'REASON_OF_ISSUE',
    REASON_STOP = 'REASON_STOP',
    REPORT_TYPE = 'REPORT_TYPE',
    REPORT_TYPE_GROUP = 'REPORT_TYPE_GROUP',
    RETURN_STATUS = 'RETURN_STATUS',
    SERVICE_CAUSE = 'SERVICE_CAUSE',
    SERVICE_REASON = 'SERVICE_REASON',
    SERVICE_STATUS = 'SERVICE_STATUS',
    SKIN_COLOR = 'SKIN_COLOR',
    SPECIAL_SERVICE_CODE = 'SPECIAL_SERVICE_CODE',
    SPECIAL_SITU_TYPE = 'SPECIAL_SITU_TYPE',
    SUSPENSION_TYPE = 'SUSPENSION_TYPE',
    SYNDICATE_DEF = 'SYNDICATE_DEF',
    WEAPON_TRADEMARK = 'WEAPON_TRADEMARK',
    LOCATION = 'LOCATION',
    TYPE_OF_VEHICLE = 'TYPE_OF_VEHICLE',
    PUNISHMENT_TYPE = 'PUNISHMENT_TYPE',
    OBJECTION_UNIT = 'OBJECTION_UNIT',
    COMMISSION_TITLE = 'COMMISSION_TITLE',
    COMMISSION_TYPE = 'COMMISSION_TYPE',
    TITLE_GROUP = 'TITLE_GROUP',
    EXCEPTIONAL_RELATION_TYPE = 'EXCEPTIONAL_RELATION_TYPE',
    CREDIBLE_EXPERIENCE_TYPE = 'CREDIBLE_EXPERIENCE_TYPE',
    BANK_CODE = 'BANK_CODE',
    EXPERIENCE_MERGE_TYPE = 'EXPERIENCE_MERGE_TYPE',
    VESTED_RIGHT_WAGE_STATUS = 'VESTED_RIGHT_WAGE_STATUS',
    INDICATOR = 'INDICATOR',
    ADDITIONAL_INDICATOR = 'ADDITIONAL_INDICATOR',
    COURSE_PRIORITY_TYPE = 'COURSE_PRIORITY_TYPE',
    ACC_TYPE = 'ACC_TYPE',
    EMPLOYEE_LEVEL = 'EMPLOYEE_LEVEL',
    SECONDMENT_REASON = 'SECONDMENT_REASON',
    PER_SECTOR = 'PER_SECTOR',
    QUALIFICATION_TYPE = 'QUALIFICATION_TYPE',
    QUALIFICATION_DATA_TYPE = 'QUALIFICATION_DATA_TYPE',
    ADVANCE_TYPE = 'ADVANCE_TYPE',
    JUDGEMENT_AUTHORITY = 'JUDGEMENT_AUTHORITY',
    MEMBER_TYPE = 'MEMBER_TYPE',
    DISABILITY_CODE = 'DISABILITY_CODE',
    LEGAL_BASIS = 'LEGAL_BASIS',
    HOUSING_TYPE = 'HOUSING_TYPE',
    VISA_APPLICATION_STATUS = 'VISA_APPLICATION_STATUS',
    NUMBER_OF_ENTRIES = 'NUMBER_OF_ENTRIES',
    COMPENSATION_TYPE = 'COMPENSATION_TYPE',
    HITAP_AUTHORIZATION_LEVEL = 'HITAP_AUTHORIZATION_LEVEL',
    ASSIGNMENT_TYPE = 'ASSIGNMENT_TYPE',
    LAW_NUMBER = 'LAW_NUMBER',
    COM_MEMBER_TYPE = 'COM_MEMBER_TYPE',
    CARD_TERMINATION_REASON = 'CARD_TERMINATION_REASON',
    MOVEMENT_REQUEST_ADD_INFO = 'MOVEMENT_REQUEST_ADD_INFO',
    EDU_EMPLOYEE_RESPONSIBILITY = 'EDU_EMPLOYEE_RESPONSIBILITY',
    KPBS_TITLE = 'KPBS_TITLE',
    EMPLOYMENT_TYPE = 'EMPLOYMENT_TYPE',
    ORGANIZATIONS_CORP = 'ORGANIZATIONS_CORP',
    POS_TRAVEL_GROUP_DOMESTIC = 'POS_TRAVEL_GROUP_DOMESTIC',
    POS_TRAVEL_GROUP_ABROAD = 'POS_TRAVEL_GROUP_ABROAD',
    TIT_TRAVEL_GROUP_DOMESTIC = 'TIT_TRAVEL_GROUP_DOMESTIC',
    TIT_TRAVEL_GROUP_ABROAD = 'TIT_TRAVEL_GROUP_ABROAD',

    /*
     * Values for Military Layer
     */
    DESCRIPTION_CODE = 'DESCRIPTION_CODE',
    CADRE_CRITERIA = 'CADRE_CRITERIA',
    UNIT_ESTABLISH_CODE = 'UNIT_ESTABLISH_CODE',
    UNIT_LEVEL = 'UNIT_LEVEL',
    ORG_OFFER_RECORD_STATUS = 'ORG_OFFER_RECORD_STATUS',
    OPERATION_TYPE = 'OPERATION_TYPE',
    MAIN_SPECIALIZATION = 'MAIN_SPECIALIZATION',
    SUB_SPECIALIZATION = 'SUB_SPECIALIZATION',
    UNIT_SUPPORT_STATUS = 'UNIT_SUPPORT_STATUS',
    ACADEMIC_LEVEL = 'ACADEMIC_LEVEL',
    PROFESSION = 'PROFESSION',
    HOSPITAL = 'HOSPITAL',
    CLINIC = 'CLINIC',
    HEALTH_REPORT_REASON = 'HEALTH_REPORT_REASON',
    HEALTH_REPORT_DECISION = 'HEALTH_REPORT_DECISION',
    RELATIONSHIP_MIL_LAYER = 'RELATIONSHIP_MIL_LAYER',
    HOSPITALIZATION_REASON = 'HOSPITALIZATION_REASON',
    ACCOMPANIST_TYPE = 'ACCOMPANIST_TYPE',
    PATIENT_CONDITION = 'PATIENT_CONDITION',
    AWARD_REASON = 'AWARD_REASON',
    PUNISHMENT_RELATED_LAW = 'PUNISHMENT_RELATED_LAW',
    PUNISHMENT_DURATION = 'PUNISHMENT_DURATION',
    SUSPECT_COUNTRY_CATEGORY = 'SUSPECT_COUNTRY_CATEGORY',
    SELECTION_GROUP_TYPE = 'SELECTION_GROUP_TYPE',
    MIL_PER_SEC_INV_REASON = 'MIL_PER_SEC_INV_REASON',
    MIL_PER_SEC_INV_RESULT = 'MIL_PER_SEC_INV_RESULT',
    REPORT_REASON = 'REPORT_REASON',
    MIL_QUALIFICATION_TYPE = 'MIL_QUALIFICATION_TYPE',
    MIL_QUALIFICATION_DATA_TYPE = 'MIL_QUALIFICATION_DATA_TYPE',
    MIL_WORK_TYPE = 'MIL_WORK_TYPE',
    NATIONALITY_TYPE = 'NATIONALITY_TYPE',
    LAWCOURT_TYPE = 'LAWCOURT_TYPE',
    LAWCOURT = 'LAWCOURT',
    COURT_DECISION = 'COURT_DECISION',
    CHARGES_CODE = 'CHARGES_CODE',
    MIL_PER_MEMO_TYPE = 'MIL_PER_MEMO_TYPE',
    PETITION_TYPE = 'PETITION_TYPE',
    PETITION_ATTACHMENT_TYPE = 'PETITION_ATTACHMENT_TYPE',
    QUA_CERT_TYPE = 'QUA_CERT_TYPE',
    EVALUATION_POSITION_GROUP = 'EVALUATION_POSITION_GROUP',
    RECRUITMENT_SOURCE = 'RECRUITMENT_SOURCE',
    MINISTRY_CODE = 'MINISTRY_CODE',
    IMPACT_ON_DUTY = 'IMPACT_ON_DUTY',
    /*
     * Values for HKDP
     */
    TRIP_EXPENSE_GROUP = 'TRIP_EXPENSE_GROUP',
    CERTIFICATE_TYPE = 'CERTIFICATE_TYPE',
    BUSINESS_FAMILY_GROUP = 'BUSINESS_FAMILY_GROUP',
    BUSINESS_FAMILY_LEVEL_HKDP = 'BUSINESS_FAMILY_LEVEL_HKDP',
    BUSINESS_FAMILY_HKDP = 'BUSINESS_FAMILY_HKDP',
    BUSINESS_FAMILY_SUB_LEVEL = 'BUSINESS_FAMILY_SUB_LEVEL',
    COMPANY = 'COMPANY',
    EXPENSE_CENTER = 'EXPENSE_CENTER',
    HVL_COMPASS_PATH = 'HVL_COMPASS_PATH',
    SPECIAL_PAYMENT_TYPE = 'SPECIAL_PAYMENT_TYPE',
    ISKUR_CODE = 'ISKUR_CODE',
    SGK_CODE = 'SGK_CODE',
    SGK_GROUP = 'SGK_GROUP',
    STRATEGIC_WORK_GROUP = 'STRATEGIC_WORK_GROUP',
    SUB_CLASS = 'SUB_CLASS',
    POSITION_GROUP = 'POSITION_GROUP',
    FOUNDATION_CLASS = 'FOUNDATION_CLASS',
    CAREER_PATH_HKDP = 'CAREER_PATH_HKDP',
    CAREER_PATH_GROUP = 'CAREER_PATH_GROUP',
    QUALIFICATION = 'QUALIFICATION',
    THESIS_TOPIC = 'THESIS_TOPIC',
    POS_EMPTY_STATUS = 'POS_EMPTY_STATUS',
    FIN_MAC_ACTIVITY_TYPE = 'FIN_MAC_ACTIVITY_TYPE',
    EXPERIENCE_GROUP = 'EXPERIENCE_GROUP',
    SUBEXPERIENCE_GROUP = 'SUBEXPERIENCE_GROUP',
    QUA_MAINGROUP = 'QUA_MAINGROUP',
    /*
     * Values for Azerbaycan
     */
    SECRET_DOCUMENT = 'SECRET_DOCUMENT',
    VISA_TYPE = 'VISA_TYPE',
    VETERAN_TYPE = 'VETERAN_TYPE',
    VETERAN_STATUS = 'VETERAN_STATUS',
    PROPOSITION_TYPE = 'PROPOSITION_TYPE',
    PROPOSITION_DECISION_TYPE = 'PROPOSITION_DECISION_TYPE',
    GUIDANCE_COUNSELING_CENTER = 'GUIDANCE_COUNSELING_CENTER',
    COUNSELING_DECISION_TYPE = 'COUNSELING_DECISION_TYPE',
    EXT_APP_STATUS = 'EXT_APP_STATUS',
    SUSPENSION_SCREEN_ADAPTATION = 'SUSPENSION_SCREEN_ADAPTATION',
    EXTERNAL_TITLE = 'EXTERNAL_TITLE',
    MOVEMENT_SUBJECT = 'MOVEMENT_SUBJECT',
    PROFICIENCY_LEVEL = 'PROFICIENCY_LEVEL',
    /*
     * Values for SAHİLNET
     */
    LAND_VEHICLE_TYPE = 'LAND_VEHICLE_TYPE',
}

export enum GeneralDiscriminatorValues {
    ACADEMIC_TITLE = 'ACADEMIC_TITLE',
    ALLOWANCE_TYPE = 'ALLOWANCE_TYPE',
    EMPLOYEE_SUBTYPE = 'EMPLOYEE_SUBTYPE',
    EMPLOYEE_TYPE = 'EMPLOYEE_TYPE',
    HRM_TYPE = 'HRM_TYPE',
    MARITAL_STATUS = 'MARITAL_STATUS',
    SERVICE_CLASS = 'SERVICE_CLASS',
    TITLE_DETAIL = 'TITLE_DETAIL',
    WORK_AREA = 'WORK_AREA',
    WORK_SUBAREA = 'WORK_SUBAREA',
    INTEGRATION_SOURCE = 'INTEGRATION_SOURCE',
    BANK_NAME = 'BANK_NAME',
    ORG_COMPANY = 'ORG_COMPANY',
    PER_EMPLOYEE_CARDS = 'PER_EMPLOYEE_CARDS',
    SUBSTITUTION_STATUS = 'SUBSTITUTION_STATUS',
    PASSPORT_TYPE = 'PASSPORT_TYPE',
    PASSPORT_STATUS = 'PASSPORT_STATUS',
    POS_AUTHORITY_LEVEL = 'POS_AUTHORITY_LEVEL',
    RD_REASON='RD_REASON',
    FILE_SUBTYPE = 'FILE_SUBTYPE',
    CALCULATION_SCRIPT_GROUP = 'CALCULATION_SCRIPT_GROUP',
    /*
     * Values for HKDP
     */
    DISCIPLINE_TYPE='DISCIPLINE_TYPE',
    /*
     * Values for Military Layer
     */
    ABBREVIATIONS = 'ABBREVIATIONS',
    PERFORMANCE_APPRAISAL_TYPE = 'PERFORMANCE_APPRAISAL_TYPE',
    QUA_CERT_TYPE = 'QUA_CERT_TYPE',
    QUA_CERT_QUESTION_TYPE = 'QUA_CERT_QUESTION_TYPE',
    SPECIAL_SITUATION_DEGREE = 'SPECIAL_SITUATION_DEGREE',
    TURNSTILE_TYPE = 'TURNSTILE_TYPE',
    TURNSTILE_PLACE = 'TURNSTILE_PLACE',
    TURNSTILE_SOURCE = 'TURNSTILE_SOURCE',
    TURNSTILE_SUB_LOCATION = 'TURNSTILE_SUB_LOCATION',
    MEASURE_UNIT = 'MEASURE_UNIT',
    AUTHORIZATION_ROLE_TYPE = 'AUTHORIZATION_ROLE_TYPE',
    ORG_ATTACHMENT = 'ORG_ATTACHMENT',
    LEGISLATION_TYPE = 'LEGISLATION_TYPE',
    UNFLEX_REASON = 'UNFLEX_REASON',
    EXPENSE_TYPE = 'EXPENSE_TYPE',
    INSURANCE_TYPE = 'INSURANCE_TYPE',
    INSURANCE_COMPANY = 'INSURANCE_COMPANY',
    CRYPTO_CARD_SUBTYPE = 'CRYPTO_CARD_SUBTYPE',
    FAMILY_MEMBER = 'FAMILY_MEMBER',
    PAYBACK_CHOICE = 'PAYBACK_CHOICE',
    CAREER_PATH_LEVEL = 'CAREER_PATH_LEVEL',
    SKILL_GROUP = 'SKILL_GROUP',
    QUALITY_GROUP = 'QUALITY_GROUP',
    REQUIREMENT_TYPE = 'REQUIREMENT_TYPE',
    QUALITY_LEVEL = 'QUALITY_LEVEL'
}

export enum PerformanceDiscriminatorValues {
    COMPETENCY_GROUP = 'COMPETENCY_GROUP',
    COMPETENCY_SUBGROUP = 'COMPETENCY_SUBGROUP',
    EVALUATOR_GROUP = 'EVALUATOR_GROUP',
    EVALUATOR_SUBGROUP = 'EVALUATOR_SUBGROUP',
    EVALUATION_UNIT_DETAIL = 'EVALUATION_UNIT_DETAIL',
    EVALUATION_SOURCE = 'EVALUATION_SOURCE',
    PERSONNEL_TYPE = 'PERSONNEL_TYPE',
    EDF_DETAIL_DELETE_REASON = 'EDF_DETAIL_DELETE_REASON',
}

export enum RecruitmentDiscriminatorValues {
    ANN_GROUP = 'ANN_GROUP',
    ANNOUNCEMENT_TYPE = 'ANNOUNCEMENT_TYPE',
    REC_LOCATION = 'REC_LOCATION',
    WORKING_TYPE = 'WORKING_TYPE',
    SKILL = 'SKILL',
    APP_TAG = 'APP_TAG',
    INT_TAG = 'INT_TAG',
    REQUIREMENT_REASON = 'REQUIREMENT_REASON',
    BUSINESS_LEVEL_GROUP = 'BUSINESS_LEVEL_GROUP',
    BUSINESS_FAMILY_LEVEL = 'BUSINESS_FAMILY_LEVEL',
    BUSINESS_FAMILY = 'BUSINESS_FAMILY',
    INTERNSHIP_TYPE = 'INTERNSHIP_TYPE',
    CAREER_PATH = 'CAREER_PATH',
    REASON_FOR_PREFERENCE = 'REASON_FOR_PREFERENCE',
    CONNECTION = 'CONNECTION',
    REASON_OFFER = 'REASON_OFFER',
    APPLICATION_METHOD = 'APPLICATION_METHOD',
    SOFT_SKILL = 'SOFT_SKILL',
    STATE_OF_EDU = 'STATE_OF_EDU',
    EDU_LANGUAGE = 'EDU_LANGUAGE',
    PRO_TERM_REASON = 'PRO_TERM_REASON',
    TRAVEL_REASON = 'TRAVEL_REASON',
    REC_EDU_INSTITUTION = 'REC_EDU_INSTITUTION',
    DEPARTMENT = 'DEPARTMENT',
    SECTOR = 'SECTOR',
    REC_FACULTY = 'REC_FACULTY',
    REC_EXAM_TYPE = 'REC_EXAM_TYPE',
    LEAVING_REASON = 'LEAVING_REASON',
    DRIVING_LICENSE_TYPE = 'DRIVING_LICENSE_TYPE',
    RELATIONSHIP = 'RELATIONSHIP',
    CERTIFICATE_TYPE = 'CERTIFICATE_TYPE',
    MEETING_LOCATION = 'MEETING_LOCATION',
    MEETING_ROOM = 'MEETING_ROOM',
    PAY_GRADE = 'PAY_GRADE',
    SOCIAL_MEDIA = 'SOCIAL_MEDIA',
    HIGH_SCHOOL_TYPE = 'HIGH_SCHOOL_TYPE',
    INT_PERIOD = 'INT_PERIOD',
    RECRUITMENT_REASON = 'RECRUITMENT_REASON',
    RESOURCE = 'RESOURCE',
    MILITARY_STATE = 'MILITARY_STATE',
    REC_CRITERIA = 'REC_CRITERIA',
    INT_LOCATION = 'INT_LOCATION',
    INT_DOMAIN = 'INT_DOMAIN',
    INTERNSHIP_STATUS = 'INTERNSHIP_STATUS',
    REC_LOCATION_CHOICE = 'REC_LOCATION_CHOICE',
    INT_DOC_TYPE = 'INT_DOC_TYPE',
    APP_DOC_TYPE = 'APP_DOC_TYPE',
    WORKING_PLACE = 'WORKING_PLACE',
}

export enum EducationDiscriminatorValues {
    COURSE_CATEGORY = 'COURSE_CATEGORY',
    ATTACHMENT_TYPE = 'ATTACHMENT_TYPE',
    BUDGET_TYPE = 'BUDGET_TYPE',
    COURSE_DEGREE = 'COURSE_DEGREE',
    QUESTION_DIFFICULTY_LEVEL = 'QUESTION_DIFFICULTY_LEVEL',
    QUESTION_GROUP = 'QUESTION_GROUP',
}

export enum PerformanceDiscriminatorGroup {
    OBJECTIVE_ATTRIBUTE = 'OBJECTIVE_ATTRIBUTE',
}

export const CodeTextDiscriminatorValues = {
    ...PersonnelDiscriminatorValues,
    ...PayrollDiscriminatorValues,
    ...GeneralDiscriminatorValues,
    ...PerformanceDiscriminatorValues,
    ...RecruitmentDiscriminatorValues,
    ...EducationDiscriminatorValues,
};

export type DiscriminatorGroup = PerformanceDiscriminatorGroup;
